import { useEffect, useRef } from 'react';
import About from '../components/About';
import Navbar from '../components/Navbar';
import Projects from '../components/Projects';
import Section1 from '../components/Section1';
import Services from '../components/Services';

function Home() {
  const section1Ref = useRef(null);
  const servicesRef = useRef(null);
  const aboutRef = useRef(null);
  useEffect(() => { 
    section1Ref.current.scrollIntoView({ behavior: "smooth" });
  },[])
  return (
    <>
      <Navbar section1={section1Ref} services={servicesRef} about={aboutRef}/>
      <Section1 section={section1Ref}/>
      <Services section={servicesRef}/>
      <About section={aboutRef}/>
      <Projects/>
    </> 
  );
}

export default Home;
